"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const appInsights_1 = require("../appInsights");
const helpers_1 = require("../helpers");
class PageManager {
    constructor(monitor) {
        this.monitor = monitor;
    }
    view({ isLoggedIn, nodeId, pageTitle, section }) {
        window.dataLayer.push({
            event: 'trackPageview',
            loginStatus: isLoggedIn ? 'logget ind' : 'logget ud',
            sidetitel: (0, helpers_1.toLowerOrEmpty)(pageTitle),
            sideId: nodeId || helpers_1.empty,
            sidesektion: (0, helpers_1.toLowerOrEmpty)(section),
        });
    }
    /**
     *Tracks error and writes it to tracelog if an ai config is provided to the TrackingManager
     */
    error({ errorcode, properties, severityLevel: severityLevel = appInsights_1.SeverityLevel.Warning, }) {
        if (errorcode) {
            window.dataLayer.push({
                event: 'trackFejlbesked',
                fejlkode: errorcode.toString(),
                fejlbeskrivelse: helpers_1.errorCodeDict[errorcode] || helpers_1.empty,
            });
            this.monitor.trace({
                message: helpers_1.errorCodeDict[errorcode] || helpers_1.empty,
                properties,
                severityLevel,
            });
        }
    }
    navigate({ type, action, destination }) {
        window.dataLayer.push({
            event: 'trackNavigation',
            navigationstype: (0, helpers_1.toLowerOrEmpty)(type),
            navigationshandling: (0, helpers_1.toLowerOrEmpty)(action),
            navigationsdestination: (0, helpers_1.toLowerOrEmpty)(destination),
        });
    }
}
exports.default = PageManager;
